import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';

/**
 * MegaMenuLink — a single navigation link within a mega menu column.
 *
 * @param {object} props
 * @param {NavigationItem} props.item
 * @param {() => void} props.onLinkClick
 * @param {boolean} [props.standalone] - When this link is the sole content of
 *   its column, cap its width so its hover/active background does not balloon
 *   into an oversized box far bigger than its text.
 */
const MegaMenuLink = ({ item, onLinkClick, standalone = false }) => (
	<a
		href={item.url}
		target={item.target || '_self'}
		className={setClassNames([
			'ws-nav-drawer__mega-menu-link',
			'd-flex',
			'align-items-center',
			'py-3',
			standalone && 'ws-nav-drawer__mega-menu-link--standalone'
		])}
		onClick={onLinkClick}
	>
		{item.label}
	</a>
);

MegaMenuLink.propTypes = {
	item: PropTypes.shape({
		label: PropTypes.string,
		url: PropTypes.string,
		target: PropTypes.string
	}).isRequired,
	onLinkClick: PropTypes.func.isRequired,
	standalone: PropTypes.bool
};

MegaMenuLink.defaultProps = {
	standalone: false
};

export default MegaMenuLink;
